// @src/pre-deployment/src/components/shared/ContactCard.js v1.0
// - Page showing a GIF with a QR code in the middle. Scanning QR opens /contact then "Save contact".
// - Put your GIF in public/ and set GIF_URL below (e.g. /contact-card.gif).

import React, { useEffect, useState } from 'react';

const BASE = typeof window !== 'undefined' ? window.location.origin + (process.env.PUBLIC_URL || '') : '';
const CONTACT_PAGE_URL = `${BASE}/contact`;

// Use a GIF from public folder, e.g. put contact-card.gif in public and use '/contact-card.gif'
const GIF_URL = process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/contact-card.gif` : '/contact-card.gif';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1a1a1a',
    padding: '1rem',
    boxSizing: 'border-box'
  },
  frame: {
    position: 'relative',
    width: '100%',
    maxWidth: '400px',
    aspectRatio: '1',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 24px rgba(0,0,0,0.3)'
  },
  gif: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },
  gifPlaceholder: {
    width: '100%',
    height: '100%',
    background: '#2a2a2a'
  },
  qrOverlay: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '220px',
    height: '220px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    borderRadius: '8px',
    padding: '8px',
    boxSizing: 'border-box'
  },
  qr: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  qrError: {
    fontSize: '12px',
    color: '#b00'
  },
  hint: {
    fontSize: '12px',
    color: 'rgba(255,255,255,0.7)',
    marginTop: '1rem',
    marginBottom: 0
  }
};

function ContactCard() {
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [qrError, setQrError] = useState('');
  const [gifFailed, setGifFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    import('qrcode').then((QRCode) => {
      if (cancelled) return;
      QRCode.default.toDataURL(CONTACT_PAGE_URL, { width: 220, margin: 1 }, (err, url) => {
        if (cancelled) return;
        if (err) setQrError(err.message || 'QR failed');
        else setQrDataUrl(url);
      });
    }).catch((e) => {
      if (!cancelled) setQrError(e.message || 'QR failed');
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="contact-card" style={styles.page}>
      <div style={styles.frame}>
        {!gifFailed ? (
          <img
            src={GIF_URL}
            alt=""
            style={styles.gif}
            onError={() => setGifFailed(true)}
          />
        ) : (
          <div style={styles.gifPlaceholder} />
        )}
        <div style={styles.qrOverlay}>
          {qrDataUrl && <img src={qrDataUrl} alt="Scan to save contact" style={styles.qr} />}
          {qrError && <span style={styles.qrError}>{qrError}</span>}
        </div>
      </div>
      <p style={styles.hint}>Scan the QR code to save this contact</p>
    </div>
  );
}

export default ContactCard;
